import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ToastService } from "angular-toastify";
import { Adventure } from "src/app/shared/models/adventure.model";
import { AuthService } from "src/app/shared/services/auth.service";
import { AdventureService } from "src/app/shared/services/adventure.service";

@Component({
	selector: "app-adventure",
	templateUrl: "./adventure.component.html",
	styleUrls: ["./adventure.component.scss"],
})
export class AdventureComponent implements OnInit {
	draftAdventures!: Adventure[];
	liveAdventures!: Adventure[];

	constructor(
		private router: Router,
		private authService: AuthService,
		private adventureService: AdventureService,
		private toastService: ToastService,
	) {}

	ngOnInit() {
		this.loadAdventures();
	}

	home() {
		this.router.navigate(["navbar"]);
	}

	async logout() {
		let data = await this.authService.logout();
		if (data) {
			this.router.navigate(["auth/login"]);
		}
	}

	loadAdventures() {
		this.loadDraftAdventures();
		this.loadLiveAdventures();
	}

	private loadDraftAdventures() {
		this.adventureService.getDraftAdventures()
			.subscribe({
				next: (res) => {
					this.draftAdventures = res;
				},
				error: (err) => {
					console.error(err);
					this.toastService.error('Failed to load draft adventures');
					this.draftAdventures = [];
				}
			});
	}

	private loadLiveAdventures() {
		this.adventureService.getLiveAdventures()
			.subscribe({
				next: (res) => {
					this.liveAdventures = res;
				},
				error: (err) => {
					console.error(err);
					this.toastService.error('Failed to load live adventures');
					this.liveAdventures = [];
				}
			})
	}
}
